import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';
import { UIIconsComponent } from '../../ui/icons/icons.component';
import { format } from "sql-formatter";

@Component({
  selector: 'app-sql-playground-modal',
  standalone: true,
  imports: [
    CommonModule,
    MarkdownModule,
    UIIconsComponent
  ],
  templateUrl: './sql-playground-modal.component.html',
  styleUrl: './sql-playground-modal.component.scss'
})
export class SqlPlaygroundModalComponent {
  @Input() show = false;
  @Input() generatedSqlOriginal = '';
  @Input() initialGeneratedSql = '';
  @Input() formattedSqlHtml = '';
  @Input() isSqlEditable = false;
  @Input() isRunSqlLoading = false;
  @Input() isSqlErrorResponse = false;
  @Input() isLatestQuery = true;
  @Input() approvedSql = '';
  @Input() disableEditing = false;
  @Input() disableRun = false;

  @Output() close = new EventEmitter<void>();
  @Output() run = new EventEmitter<boolean>();
  @Output() edit = new EventEmitter<void>();
  @Output() sqlContentChanged = new EventEmitter<Event>();
  @Output() runEdited = new EventEmitter<void>();
  @Output() cancelEdit = new EventEmitter<void>();

  getFormattedSql(): string {
    const sql = this.approvedSql || this.generatedSqlOriginal || '';
    const formatted = format(sql, {
      language: 'sql',
      tabWidth: 2, 
      keywordCase: 'upper'
    });
    return '```sql\n' + formatted + '\n```';
  }

  onSqlContentEdit(event: Event): void {
    this.sqlContentChanged.emit(event);
  }

  copySQl(): void {
    if (this.generatedSqlOriginal) {
      navigator.clipboard
        .writeText(this.generatedSqlOriginal)
        .then(() => {})
        .catch((err) => {
          console.error('Failed to copy text: ', err);
        });
    }
  }

  runSQL(isRefresh = false): void {
    this.run.emit(isRefresh);
  }

  enableSqlEditing(): void {
    this.edit.emit();
  }

  closeShowSqlModal(): void {
    this.close.emit();
  }
}